module.exports = __webpack_public_path__ + "static/assets/ff7a2f7f68e451d2b403c5e34570ec68.svg";